import { useMemo } from 'react';
import { difference } from 'lodash';
import { useGlobalSettingsContext } from 'contexts/GlobalSettingsContext';
import { FINDING_STATUS } from "views/Findings/Constants";

const UNRESOLVED_STATUS = [
    FINDING_STATUS.OPEN,
    FINDING_STATUS.CONFIRMED,
    FINDING_STATUS.ACCEPT_RISK,
    FINDING_STATUS.FALSE_POSITIVE,
    FINDING_STATUS.SUPPRESSED,
    FINDING_STATUS.TRIAGE,
    FINDING_STATUS.IN_PROGRESS,
    FINDING_STATUS.CONTROLLED,
];

export default function useUnResolvedFindingStatus() {
    const { mitigatedStatus, disabledFindingStatus } = useGlobalSettingsContext();
    const unResolvedStatus = useMemo(() => {
        const endIndex = UNRESOLVED_STATUS.length;
        let status = difference(UNRESOLVED_STATUS.slice(0, endIndex), mitigatedStatus);
        status = difference(status, disabledFindingStatus);
        
        return status;
    }, [mitigatedStatus, disabledFindingStatus]);

    return unResolvedStatus;
}